import { PropsWithChildren } from 'react';

interface ScrollSectionProps extends PropsWithChildren {
	name: string;
}

export const ScrollSection = ({ children, name }: ScrollSectionProps) => {
	return (
		<section id={name} key={name}>
			{children}
		</section>
	);
};
